angular
  .module('middlewares.isAdmin', ['resources.AdminUser'])
  .service('isAdmin', ["User", "$state", function (User, $state) {

    return function (next) {
      User.current(function (user) {
        if (user && user.is_active && user.is_admin) {
          return next();
        }

        return $state.go('unauthorized');
      });
    };

  }]);



// WEBPACK FOOTER //
// ./client/src/common/middlewares/isAdmin.js